import moment from 'moment';
import React, { useEffect, useState } from 'react';

import BarChart from '../../elements/BarChart';
import YearSwitch from '../../elements/YearSwitch';
import axios from '../../services/MyAxios';

import Card from 'crm/elements/common/Card';

function UserDepositsChart({ url, minDate }: Readonly<{ url: string; minDate: string }>) {
    const [data, setData] = useState([]);
    const minYear = moment(minDate).year();
    const [year, setYear] = useState<number>(moment().year());

    useEffect(() => {
        axios.get(url, { params: { year } }).then((response) => setData(response.data));
    }, [year]);

    return (
        <Card anchorName="User deposits" cardClass="border-bottom shadow border-info">
            <div className="d-flex no-block align-items-center">
                <h6 className="text-info">User deposits</h6>
            </div>
            <div className="deposit-chart">
                <BarChart data={data} />
            </div>
            <YearSwitch minYear={minYear} currentYear={year} setYear={setYear} />
        </Card>
    );
}

export default UserDepositsChart;
